import { createReporter } from 'whisper-core-api';

const reporter = createReporter('[nudge-custom-function-registry]');

export const captureMessage = reporter.captureMessage;
export const captureError = reporter.captureError;
